import DownloadRequestPage from '../../../shared/reportDownloads/DownloadRequestPage'
import {DownloadRequestConfig} from '../../../shared/reportDownloads/DownloadRequestConfig'

const config: DownloadRequestConfig = {
  isKpi: false,
  authPermission: 'reports.export',
}

const ReportDownloadsPage = () => <DownloadRequestPage config={config} />

export default ReportDownloadsPage
